import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { Toaster } from '@/components/ui/sonner';
import { LoginPage } from '@/pages/LoginPage';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { RequireAdmin } from '@/components/auth/RequireAdmin';
import { PartnerSidebarLayout } from '@/components/layout/PartnerSidebarLayout';
import { DashboardPage } from '@/pages/dashboards/DashboardPage';
import { SubscriptionsPage } from '@/pages/dashboards/SubscriptionsPage';
import { RevenuePage } from '@/pages/dashboards/RevenuePage';
import { FollowUpDashboardPage } from '@/pages/dashboards/FollowUpDashboardPage';
import { GroupsPage } from '@/pages/groups/GroupsPage';
import { GroupDetailPage } from '@/pages/groups/GroupDetailPage';
import { ActivityPage } from '@/pages/activity/ActivityPage';
import { PlansPage } from '@/pages/plans/PlansPage';
import { PromoCodesPage } from '@/pages/promo-codes/PromoCodesPage';
import { InvoicesPage } from '@/pages/invoices/InvoicesPage';
import { PartnersPage } from '@/pages/PartnersPage';
import { ProfilePage } from '@/pages/ProfilePage';

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <ProtectedRoute>
              <PartnerSidebarLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/revenue" element={<RevenuePage />} />
          <Route path="/follow-up" element={<FollowUpDashboardPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/groups/:uuid" element={<GroupDetailPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/promo-codes" element={<PromoCodesPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            path="/activity"
            element={
              <RequireAdmin>
                <ActivityPage />
              </RequireAdmin>
            }
          />
          <Route
            path="/partners"
            element={
              <RequireAdmin>
                <PartnersPage />
              </RequireAdmin>
            }
          />
        </Route>

        <Route path="/growth" element={<Navigate to="/dashboard" replace />} />
        <Route path="/demographics" element={<Navigate to="/dashboard" replace />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
